import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PoModalComponent, PoSelectOption } from '@po-ui/ng-components';
import { ApiService } from '../../../shared/service/api.service';

@Component({
  selector: 'app-modal-person-statistics',
  templateUrl: './modal-person-statistics.component.html',
  styleUrls: ['./modal-person-statistics.component.css']
})
export class ModalPersonStatisticsComponent implements OnInit {
  @ViewChild('chart', { static: false }) chart!: PoModalComponent;
  @Input() personSelect: any;
  @Input() personStatisticsInfo: any;
  @Input() limitPersonInfo: any;
  @Input() openInvoiceValue: any;
  @Input() branchCodes: any[] = [];

  originalBranchCodes: any[] = [];
  selectedCompanyFilter: any = 0;
  hasError: boolean = false;
  errorMessage: string = '';
  companyFilterOptions: Array<PoSelectOption> = [
    { label: 'Empresas do filtro', value: 0 },
    { label: 'Todas as empresas', value: 1 }
  ];

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  onCompanyFilterChange(item: any) {
    this.selectedCompanyFilter = item;
    this.hasError = false;
    this.errorMessage = '';
    
    if (item === 0) {
      const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
      
      let branchesToUse = null;
      
      if (filterInfoBranchs) {
        try {
          branchesToUse = JSON.parse(filterInfoBranchs);
        } catch (error) {
          console.error('Erro ao processar filterInfoBranchs:', error);
        }
      }
      
      if (!branchesToUse || !Array.isArray(branchesToUse) || branchesToUse.length === 0) {
        branchesToUse = this.originalBranchCodes;
      }
      
      if (branchesToUse && Array.isArray(branchesToUse) && branchesToUse.length > 0) {
        this.updatePersonData(branchesToUse);
      } else {
        this.hasError = true;
        this.errorMessage = 'Nenhuma empresa selecionada no filtro';
      }
    } else if (item === 1 && this.originalBranchCodes && this.originalBranchCodes.length > 0) {
      this.api.getPoolBranches(this.originalBranchCodes).subscribe(
        (response: any) => {
          const poolBranchCodes = response.items
            .map((branch: any) => branch.branchCode)
            .filter((code: any) => code !== null && code !== undefined && code !== '');
          
          this.updatePersonData(poolBranchCodes);
        },
        (error: any) => {
          console.error('Erro ao buscar pool branches:', error);
          this.hasError = true;
          this.errorMessage = 'Erro ao buscar empresas do pool';
        }
      );
    }
  }

  updatePersonData(branchCodes: any[]) {
    const validBranchCodes = branchCodes.filter((code: any) => code !== null && code !== undefined && code !== '');
    
    if (validBranchCodes.length === 0) {
      console.error('Nenhum branch code válido para atualizar');
      this.hasError = true;
      this.errorMessage = 'Nenhuma empresa válida para consulta';
      return;
    }
    
    this.api.getPersonStatistics(this.personSelect.personCode, validBranchCodes).subscribe(
      (data: any) => {
        this.personStatisticsInfo = data;
        this.hasError = false;
        this.errorMessage = '';
      },
      (error: any) => {
        console.error('Erro ao buscar estatísticas da pessoa:', error);
        
        if (error.status === 400 && error.error && Array.isArray(error.error)) {
          const notAllowedErrors = error.error.filter((err: any) => err.code === 'ValueNotAllowed');
          
          if (notAllowedErrors.length > 0) {
            if (validBranchCodes.length === 1) {
              this.hasError = true;
              this.errorMessage = `A empresa ${validBranchCodes[0]} não está liberada para este usuário`;
              return;
            }
            
            const notAllowedBranches = error.error
              .filter((err: any) => err.code === 'ValueNotAllowed' && err.message.includes('BranchCode'))
              .map((err: any) => {
                const match = err.message.match(/BranchCode (\d+) not allowed/);
                return match ? parseInt(match[1]) : null;
              })
              .filter((code: any) => code !== null);
            
            if (notAllowedBranches.length > 0) {
              console.log('Branches não permitidos:', notAllowedBranches);
              const allowedBranches = validBranchCodes.filter((code: any) => !notAllowedBranches.includes(code));
              console.log('Tentando novamente apenas com branches permitidos:', allowedBranches);
              
              if (allowedBranches.length > 0) {
                this.updatePersonData(allowedBranches);
                return;
              } else {
                this.hasError = true;
                this.errorMessage = `Nenhuma empresa está liberada para este usuário`;
                return;
              }
            }
          }
        }
        
        this.hasError = true;
        this.errorMessage = 'Erro ao buscar estatísticas do cliente';
      }
    );

    this.api.postCustomerFinancialBalance(this.personSelect.personCode, validBranchCodes).subscribe(
      (data: any) => {
        const invoiceValue = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.openInvoiceValue, 0);
        this.limitPersonInfo = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.limitValue, 0);
        this.openInvoiceValue = this.limitPersonInfo - invoiceValue;
      },
      (error: any) => {
        console.error('Erro ao buscar limite financeiro:', error);
        

        if (error.status === 400 && error.error && Array.isArray(error.error)) {
          const notAllowedBranches = error.error
            .filter((err: any) => err.code === 'ValueNotAllowed' && err.message.includes('BranchCode'))
            .map((err: any) => {
              const match = err.message.match(/BranchCode (\d+) not allowed/);
              return match ? parseInt(match[1]) : null;
            })
            .filter((code: any) => code !== null);
          
          if (notAllowedBranches.length > 0) {
            const allowedBranches = validBranchCodes.filter((code: any) => !notAllowedBranches.includes(code));
            
            if (allowedBranches.length > 0) {
              this.api.postCustomerFinancialBalance(this.personSelect.personCode, allowedBranches).subscribe(
                (data: any) => {
                  const invoiceValue = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.openInvoiceValue, 0);
                  this.limitPersonInfo = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.limitValue, 0);
                  this.openInvoiceValue = this.limitPersonInfo - invoiceValue;
                }
              );
            }
          }
        }
      }
    );
  }

  open(personSelect: any, branchCodes?: any[]) {
    this.personSelect = personSelect;
    
    if (branchCodes && branchCodes.length > 0) {
      this.originalBranchCodes = [...branchCodes];
    } else {
      const filterAllBranchs = localStorage.getItem("filterAllBranchs");
      if (filterAllBranchs) {
        this.originalBranchCodes = JSON.parse(filterAllBranchs);
      } else {
        const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
        this.originalBranchCodes = filterInfoBranchs ? JSON.parse(filterInfoBranchs) : [];
      }
    }
    
    this.selectedCompanyFilter = 0;
    this.hasError = false;
    this.errorMessage = '';
    
    const filterInfoBranchs = localStorage.getItem("filterInfoBranchs");
    
    let branchesToUse = null;
    
    if (filterInfoBranchs) {
      try {
        branchesToUse = JSON.parse(filterInfoBranchs);
      } catch (error) {
        console.error('Erro ao processar filterInfoBranchs:', error);
      }
    }
    
    if (!branchesToUse || !Array.isArray(branchesToUse) || branchesToUse.length === 0) {
      if (branchCodes && Array.isArray(branchCodes) && branchCodes.length > 0) {
        branchesToUse = branchCodes;
      }
    }
    
    if (!branchesToUse || !Array.isArray(branchesToUse) || branchesToUse.length === 0) {
      branchesToUse = this.originalBranchCodes;
    }
    
    if (branchesToUse && Array.isArray(branchesToUse) && branchesToUse.length > 0) {
      this.loadPersonData(personSelect.personCode, branchesToUse);
    } else {
      this.hasError = true;
      this.errorMessage = 'Nenhuma empresa selecionada no filtro';
    }
    
    this.chart.open();
  }

  loadPersonData(personCode: any, branchCodes: any[]) {
    this.api.getPersonStatistics(personCode, branchCodes).subscribe(
      (data: any) => {
        this.personStatisticsInfo = data;
        this.hasError = false;
        this.errorMessage = '';
      },
      (error: any) => {
        console.error('Erro ao buscar estat\u00edsticas:', error);
        this.handlePersonDataError(error, personCode, branchCodes);
      }
    );
    
    this.api.postCustomerFinancialBalance(personCode, branchCodes).subscribe(
      (data: any) => {
        const invoiceValue = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.openInvoiceValue, 0);
        this.limitPersonInfo = data.items[0].values.reduce((acc: any, curr: any) => acc + curr.limitValue, 0);
        this.openInvoiceValue = this.limitPersonInfo - invoiceValue;
      },
      (error: any) => {
        console.error('Erro ao buscar limite financeiro:', error);
      }
    );
  }

  handlePersonDataError(error: any, personCode: any, branchCodes: any[]) {
    if (error.status === 400 && error.error && Array.isArray(error.error)) {
      const notAllowedErrors = error.error.filter((err: any) => err.code === 'ValueNotAllowed');
      
      if (notAllowedErrors.length > 0 && branchCodes.length === 1) {
        this.hasError = true;
        this.errorMessage = `A empresa ${branchCodes[0]} não está liberada para este cliente`;
      }
    } else {
      this.hasError = true;
      this.errorMessage = 'Erro ao buscar estatísticas do cliente';
    }
  }

  formatDateFull(item: any) {
    if (!item) {
      return '00/00/0000';
    }
    const date = new Date(item);
    if (isNaN(date.getTime())) {
      return '00/00/0000';
    }
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return date.toLocaleDateString('pt-BR', options);
  }

}
